export default __webpack_public_path__ + "static/media/litho-inner-page-slider-03.06dadc60.jpg";